import React, { useState, useEffect } from 'react'
import { buildLocalePath } from "components/utils/Locale";
import { EXDefaultImage } from "components/utils/DefaultImage";

function ExcursionImage(props) {

    const [imageSRC, setImage] = useState("");
    const [loaded, setLoaded] = useState(false);
    const [loadClass, setLoadClass] = useState("hidden");
    const [alt, setAlt] = useState("");
    useEffect(() => {
        if (props.product && (props.product.excursion_images_cover_only || []).length > 0) {
            setImage(props.image_format == "medium" ? props.product.excursion_images_cover_only_medium : props.product.excursion_images_cover_only_large)
        } else {
            setImage((props.image_format == "medium" ? props.product.excursion_images_medium : props.product.excursion_images_large))
        }
        setAlt(props.product.excursion_image_alt)
    }, [props.product]);

    function onError() {
        setImage(EXDefaultImage)
        setLoaded(true)
        setLoadClass("")
    }

    function onLoad() {
        setLoadClass("")
        setLoaded(true)
    }

    function handleClick() {
        if (props.createSelectItemDataLayer) {
            props.createSelectItemDataLayer()
        }
    }

    const imgBlock = (
        <>
            <img className={"lazyload " + loadClass}
                alt={alt}
                src={imageSRC}
                onLoad={onLoad}
                onError={onError}
            />
            {
                !loaded &&
                <div
                  className="lazyload oi-skeleton oi-skeleton--wave skeleton-aspect-ratio oi-w-full"
                  style={{
                    aspectRatio: props.aspect_ratio || '1/1',
                    height: 'auto'
                  }}
                  aria-hidden
                />
            }
        </>
    );

    return (
        <figure>
            {props.omitLink ? imgBlock : (
                <a href={buildLocalePath("products/" + (props.product.slug != null ? props.product.slug : props.product.id))} target="_blank" rel="noopener noreferrer" onClick={handleClick}>
                    {imgBlock}
                </a>
            )}
        </figure>

    );
}

export default ExcursionImage
